export default Object.freeze({
    RECOMMENDED: 'recommended',
    // Non-recommended sort must match supported BE API sortBy enum values
    // https://api.ratehub.dev/credit-cards-service/api-docs/#/default/post_rewards
    FIRST_YEAR_VALUE: 'first-year-net-value',
    SUBSEQUENT_YEAR_VALUE: 'subsequent-years-net-value',
    WELCOME_BONUS: 'welcome-sign-up-bonus',
    ANNUAL_FEE: 'annual-fee',
});
